define.alias("shared/helpers/is-present", "media/helpers/is-present");